import PropTypes from 'prop-types';
import React from 'react';

import { TableWrapper, ViewTransactionButton } from '../../components';
import { useOpenTransactionDetails } from '../../hooks';
import { useFetchTransactions } from '../../hooks/queries';

const WalletTransactions = ({ wallets, currencyId }) => {
  let currentWallet = wallets.find(
    ({ currency: { slug } }) => slug && slug.toLowerCase() === currencyId
  );
  const { transactions, isLoading } = useFetchTransactions(
    currentWallet && currentWallet.currency_id
  );
  let showIsFetching = (!transactions.length && isLoading) || false;
  const openTransactionDetails = useOpenTransactionDetails();

  return currentWallet ? (
    <div className="wallets">
      <TableWrapper
        title={`Recent ${currentWallet.currency.name.toLowerCase()}`}
        data={transactions}
        isFetching={showIsFetching}
        name="transactions"
        link="/transactions"
        rowAction={
          openTransactionDetails
            ? (transaction) => (
                <ViewTransactionButton transaction={transaction} onView={openTransactionDetails} />
              )
            : undefined
        }
      />
    </div>
  ) : (
    ''
  );
};

WalletTransactions.propTypes = {
  wallets: PropTypes.array,
  currencyId: PropTypes.string
};

export { WalletTransactions };
